module.exports = __webpack_public_path__ + "img/Rhodium Stains.9215ae30.png";